import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { getTrainingClass, fetchTrainingClass } from '../../../store/client'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import DetailViewController from '../../../shared/ui/DetailViewController'
import Button from '../../../shared/ui/Button'
import Text from '../../../shared/ui/Text'
import Section from '../../../shared/ui/Section'
import InfoSection from '../../../shared/ui/InfoSection'
import DateCard from '../../../shared/ui/DateCard'
import StatusLabel from '../../../shared/ui/StatusLabel'
import { capitalize, secondsToTime, isValid } from '../../../shared/utilities/helpers'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import BackIcon from '@material-ui/icons/ArrowBackIos'
import Box from '@material-ui/core/Box'
import LanguageIcon from '@material-ui/icons/Language'
import BusinessIcon from '@material-ui/icons/Business'

const styles = theme => ({
  root: {
  },
  iconLabel: {
    color: theme.palette.primary.main,
    marginRight: theme.spacing(0.5)
  }
})

const TrainingClassDetailController = ({ theme, classes, ...props }) => {
  const { trainingClassKey, isFetching, lastFetched, data, fetchTrainingClass } = props
  
  const navigationContext = useContext(NavigationContext)

  const TrainingClassStatusColor = {
    'Ready to Deliver': '#00aa00',
    'Canceled': '#aaaaaa',
    'Completed': '#000000' 
  }

  useEffect(() => {
    fetchTrainingClass(true)
  }, [])  
  
  const backButton = (
    <Button icon={BackIcon} onClick={() => navigationContext.openLink("/company/trainingclass")}>
      Training Classes
    </Button>
  )
  
  let infoItems = []
  if (lastFetched) {
    infoItems.push({ label: 'Class No', value: data.training_class_no || '-' })

    infoItems.push({ 
      label: 'Class Type', 
      // value: data.customer_type == 'public' ? "Public" : "Private" 
      value : 
        <Box display='flex' alignItems='center'>
          { data.customer_type != 'public' ?
            <>
              <BusinessIcon className={classes.iconLabel} style={{ color: 'black' }} />
              <Typography>Private</Typography>
            </>
            :
            <>
              <LanguageIcon className={classes.iconLabel} style={{ color: 'black' }}/>
              <Typography variant='body1'>Public</Typography>
            </>
          }
        </Box>
    })
    
    if (data.delivery_method == 'online') {
      infoItems.push({ label: 'Delivery Type', value: `Online via ${data.delivery_app || 'Zoom'}` })
    }
    else {
      infoItems.push({ label: 'Delivery Type', value: 
        <>
          Offline
          { data.venue &&
            <>
              <Typography>
                Location: { data.venue.state } - { data.venue.line4 }
              </Typography>
              <Typography>
                Venue:  { data.venue.in_house ? 'In House' : 'Arranged By PasarTrainer' }
              </Typography>
            </>              
          }
        </>

      })
    }
    
    let date = moment(data.training_date).format('DD MMM YYYY')
    
    if (data.start_time && data.start_time > 0) {
      date = (
        <Box display='flex'>
          { data.schedules && data.schedules.length > 0 && data.schedules.map(item => 
            <DateCard item={ item.training_date }/>
          )}
          { data.schedules && data.schedules.length <= 0 &&
            <DateCard item={ data.training_date }/>
          }
        </Box>
      )
    }
            
    infoItems.push({ label: 'Training Date', value: date })
    
    let status = data.status
    infoItems.push({ label: 'Status', value: (
      <StatusLabel
        color={TrainingClassStatusColor[status] || '#555'}
        >
        { status }
      </StatusLabel>
      )})    
  }  
  
  return (
    <DetailViewController
      title={lastFetched && data.course ? data.course.name : ''}
      isFetching={isFetching}
      lastFetched={lastFetched}
      backButton={backButton} 
      >
      { lastFetched &&
        <>
          <Box mt={2} />
          
          <InfoSection gutterBottom
            items={infoItems}
            />
            
          <Section title="Course Detail" gutterBottom>
            <Section variant='subsection'>
              <Typography variant='h6' style={{ fontWeight: 600 }}>
                { data.course.name }
              </Typography>
            </Section>
            <Section title='Trainer' variant='subsection'>
              <Typography variant='body1'>
                { data.trainer.first_name } { data.trainer.last_name }
              </Typography>
            </Section>
            
            { data.notes &&
              <Section title="Notes" variant="subsection" gutterBottom>
                <Text text={data.notes} format='markdown' />
              </Section>
            }       
                   
          </Section>
        
          {/*
          <Section title="Syllabus" gutterBottom>
            <CourseContentsView course={data.course} />
          </Section>
          */}
          
        </>
      }
    </DetailViewController>
  )
}

const mapStateToProps = (state, ownProps) => {
  let trainingClassKey = ownProps.match.params.trainingClassKey
    
  return {
    trainingClassKey,
    ...getTrainingClass(state, trainingClassKey)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  let trainingClassKey = ownProps.match.params.trainingClassKey
  return {
    fetchTrainingClass: (refresh) => {
      dispatch(fetchTrainingClass(trainingClassKey, true))
    }
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(TrainingClassDetailController)
)
